$(document).ready(function() {
  $('.header__mobile__button .header__mobile__hamburger .hamburger__lines').click(function(){
  $('.header__wrapper header.theme__header').toggleClass("cstm-nav-visible");
    });
  $('.search__popdown__outer .search__popdown__main .search__popdown__close .search__popdown__close__inner').click(function(){
if($('.header__wrapper header.theme__header.cstm-nav-visible').hasClass("cstm-nav-visible")){
$('.header__wrapper header.theme__header.cstm-nav-visible').removeClass("cstm-nav-visible");
}
});

var offset = 70;
$("a.day-level-link").click(function() {
    $('html, body').animate({
        scrollTop: $("div#day-level-up-guarantee").offset().top - offset
    }, 1000);	
});
$("a.exchange-policy-link").click(function() {
    $('html, body').animate({
        scrollTop: $("div#exchange_policy").offset().top - offset
    }, 1000);
});
   $("a.return-link").click(function() {
    $('html, body').animate({
        scrollTop: $("div#sale_promotion").offset().top - offset
    }, 1000);
});
$("a.refunds-link").click(function() {
    $('html, body').animate({
        scrollTop: $("div#refunds").offset().top - offset
    }, 1000);
});
$("a.dublicate").click(function() {
    $('html, body').animate({
        scrollTop: $("div#duplicate-orders").offset().top - offset
    }, 1000);
});
$("a.damaged-link").click(function() {
    $('html, body').animate({
        scrollTop: $("div#damaged-products").offset().top - offset
    }, 1000);
});
  
});